{
  "version": 1,
  "asset_id": "b9dff175-21ea-4b5d-aef0-8313a3d41d08",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b9dff175-21ea-4b5d-aef0-8313a3d41d08/hiatal-type-2-sleeve-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b9dff175-21ea-4b5d-aef0-8313a3d41d08/hiatal-type-2-sleeve-es-800.webp",
  "original_filename": "hiatal-type-2-sleeve-es-800.webp",
  "size": 41028,
  "content_type": "image/webp",
  "created_at": "2026-09-26T22:45:56Z"
}
